import { Consultant } from './common'

export enum MbusinessStatus {
  in_process = 'in_process',
  waiting = 'waiting',
  error = 'error',
  denied = 'denied',
  given = 'given',
  notfound = 'notfound',
  failed = 'failed',
}

export interface Mbusiness {
  id: string
  created_at: string
  jira_key: string
  status: MbusinessStatus

  get_status_display: string
  consultant?: Consultant
  name: string
  rko_account: string
  transit_1: string
  transit_2: string
  pan: string
  add_pan: string
  revision_application: string
  customfield_14725: string
  other_documents?: Array<{
    id: number
    mbusiness: string
    file: string
  }>
}
